import { AlertConstant } from './constants/AlertConstant'
import { Translate as t } from '../config/Translate';
import { resolveServerErrorMessage } from '../lib/serverErrorMessage';

const Success = (message) => async (dispatch) => {
    return dispatch({ type: AlertConstant.SUCCESS, message });
}

// BUG-227 (#446): 표시 문자열은 액션에서 확정하고, 서버 원본 코드는 code 로 따로 보낸다.
// (소비처 src/pages/admin/AdminProductInfo.js:61 이 원본 코드를 정확히 비교하므로 가공하면 안 된다)
// IMP-479 U-40: axios 오류·Error 는 response.data(서버 실패 본문)에서 사유를 읽는다.
// 오류 객체의 message 는 서버 예외 원문일 수 있어 화면에 내지 않고 warn 에만 남긴다.
const Error = (data) => async (dispatch) => {
    if (!data) return;
    if (typeof data === 'string') {
        return dispatch({ type: AlertConstant.ERROR, data: [], message: data, code: '' });
    }
    const isErrorLike = data.isAxiosError === true || !!data.response || data instanceof globalThis.Error;
    let body = data;
    if (isErrorLike) {
        body = data.response?.data;
        if (!body || typeof body !== 'object') {
            console.warn('[AlertAction.Error] no response body', {
                status: data.response?.status,
                name: data.name,
                message: typeof data.message === 'string' ? data.message.slice(0, 200) : undefined,
            });
            return dispatch({
                type: AlertConstant.ERROR,
                data: [],
                message: t('common.message.error.processingFailed'),
                code: '',
            });
        }
    }
    const { message, code, errors } = resolveServerErrorMessage(body, t);
    return dispatch({ type: AlertConstant.ERROR, data: errors, message, code });
}

const ErrorMsg = (message) => async (dispatch) => {
    return dispatch({ type: AlertConstant.ERRORMSG, message });
}

function Closed() {
    return { type: AlertConstant.CLOSED };
}

function Clear() {
    return { type: AlertConstant.CLEAR };
}

export const AlertAction = {
    Success,
    Error,
    ErrorMsg,
    Clear,
    Closed,
}
